/**
 * HTML character references in provider names, decoded once at parse time.
 *
 * Panels store names through web forms, so some arrive escaped: a category
 * "LIVE | &#127875; Halloween Movies", a film "Tom &amp; Jerry". Shown as sent,
 * the viewer reads the code (TiviGlass does, from the owner's provider,
 * 2026-10-19). Only character references are decoded; a name is never treated
 * as markup, and React escapes it again when it is drawn.
 *
 * `&amp;` goes last, so "&amp;#38;" stays the text "&#38;" rather than being
 * decoded twice.
 */
const NAMED = {
    lt: "<",
    gt: ">",
    quot: '"',
    apos: "'",
    nbsp: " ",
};
export function decodeEntities(value) {
    if (!value.includes("&"))
        return value;
    return value
        .replace(/&#x([0-9a-f]{1,6});/gi, (match, hex) => fromCode(Number.parseInt(hex, 16), match))
        .replace(/&#(\d{1,7});/g, (match, dec) => fromCode(Number(dec), match))
        .replace(/&(lt|gt|quot|apos|nbsp);/gi, (match, name) => NAMED[name.toLowerCase()] ?? match)
        .replace(/&amp;/gi, "&");
}
/** A code point, or the reference left as it was when it names no character. */
function fromCode(code, original) {
    if (!Number.isInteger(code) || code <= 0 || code > 0x10ffff || (code >= 0xd800 && code <= 0xdfff))
        return original;
    return String.fromCodePoint(code);
}
//# sourceMappingURL=entities.js.map